import { useTranslation } from "react-i18next";

import { getStatus, StatusIcon } from "@dashboard/shared/components/StatusIcon";
import { CellContext } from "@tanstack/react-table";

import { GroupOverviewData } from "../../GroupPage.utils";

export const OnlineStatusIcon = (props: CellContext<GroupOverviewData, unknown>) => {
    const { t } = useTranslation(["pages", "common"]);
    const { onlineDevices, devicesWithConnectionStatus } = props.row.original;

    if (devicesWithConnectionStatus === 0) {
        return <StatusIcon status="none" tooltip={t("common:tooltip.groupIsEmpty")} />;
    }
    return (
        <StatusIcon
            status={getStatus(onlineDevices, devicesWithConnectionStatus)}
            tooltip={t("pages:groupPage.tooltip.onlineDevices", { count: onlineDevices, total: devicesWithConnectionStatus })}
        />
    );
};

const useNoPolicyTooltip = (row: GroupOverviewData) => {
    const { t } = useTranslation(["pages", "common"]);
    if (row.numberOfDevices === 0) {
        return t("common:tooltip.groupIsEmpty");
    }
    return row.hasEmptyPolicy ? t("common:tooltip.policyHasNoRules") : t("pages:groupPage.tooltip.noDevicesWithPolicy");
};

export const CoverageStatusIcon = (props: CellContext<GroupOverviewData, unknown>) => {
    const { t } = useTranslation(["pages", "common"]);
    const row = props.row.original;
    const noPolicyTooltip = useNoPolicyTooltip(row);

    if (row.devicesWithPolicy === 0) {
        return <StatusIcon status="none" tooltip={noPolicyTooltip} />;
    }
    return (
        <StatusIcon
            status={getStatus(row.devicesWithPolicy, row.numberOfDevices)}
            tooltip={t("pages:groupPage.tooltip.devicesWithPolicy", { count: row.devicesWithPolicy, total: row.numberOfDevices })}
        />
    );
};

export const ComplianceStatusIcon = (props: CellContext<GroupOverviewData, unknown>) => {
    const { t } = useTranslation(["pages", "common"]);
    const row = props.row.original;
    const noPolicyTooltip = useNoPolicyTooltip(row);

    if (row.devicesWithPolicy === 0) {
        return <StatusIcon status="none" tooltip={noPolicyTooltip} />;
    }
    return (
        <StatusIcon
            status={getStatus(row.compliantDevices, row.devicesWithPolicy)}
            tooltip={t("pages:groupPage.tooltip.compliantDevicesWithPolicy", {
                count: row.compliantDevices,
                total: row.devicesWithPolicy,
            })}
        />
    );
};
